import ko from 'knockout';

//GFW - 06/2017
//This function allows you to define an observable that can be updated silently (without triggering subscriber notifications)
//I found the basis for the code here: https://stackoverflow.com/questions/17983118/change-observable-but-dont-notify-subscribers-in-knockout-js
//
//Example: 
//          this.name = ko.observable("Bob").withSilentUpdates();
//          this.name.silentUpdate("Ted");
//
ko.observable.fn.withSilentUpdates = function () {

  this.notifySubscribers = function () {
    if (!this.silenceNotifications) {
      ko.subscribable.fn.notifySubscribers.apply(this, arguments);
    }
  };

  this.silentUpdate = function (newValue) {
    this.silenceNotifications = true;
    this(newValue);
    this.silenceNotifications = false;
  };

  return this;
};